export default "__VITE_ASSET__426ab00d__"